import {createSlice} from "@reduxjs/toolkit";
import {THEME_LIGHT} from '../../config/constant/projectConstant';
import { NOTIFICATION_COUNT } from "../../constants/projectConstants";

const initialUserpilotState = () => ({
  isCameraRotate: false,
  isCameraPan: false,
  isCameraZoomInOut: false,
  isPropSelected: false,
  isPropFocused: false,
  isAxisSelected: false,
  isGizmoHighlighted: false,
});

const activity = createSlice({
  name: 'activity',
  initialState: {
    theme: THEME_LIGHT,
    navPath: '',
    name: '',
    notificationCount: 0,
    userpilotActionStates: initialUserpilotState(),
    userpilotSavedSteps: null,
    userpilotOnboardingInfo: null, // {id: null,name: null,token: null,isRunning: false,},
    currentLoggedInInfo: {
      isSelfServePlan: false,
      isFreemiumUser: false,
      isPremiumUser: false,
      isFreemiumOrSelfServeUser: false,
      isPremiumAndSelfServePlan: false,
      isOldSubscriptionUser: false,
    },
    isChatBotAvailable: false,
    callGetProductAPI: false,
    frappeRequestData: { url: null, fetchedForOrg: null },
    globalAlertData: '',
  },
  reducers: {
    setTheme: (state, { payload }) => {
      state.theme = payload;
    },
    setNavPath: (state, { payload }) => {
      state.navPath = payload;
    },
    setName: (state, { payload }) => {
      state.name = payload;
    },
    setNotificationCount: (state, { payload }) => {
      state.notificationCount = payload;
      localStorage.setItem(NOTIFICATION_COUNT, payload);
    },
    setUserpilotOnboardingInfo: (state, { payload }) => {
      state.userpilotOnboardingInfo =
        payload === null ? null : { ...(state.userpilotOnboardingInfo || {}), ...payload };
    },
    setUserpilotActionStates: (state, { payload }) => {
      state.userpilotActionStates = { ...initialUserpilotState(), ...payload };
    },
    setUserpilotSavedSteps: (state, { payload }) => {
      state.userpilotSavedSteps = payload;
    },
    resetUserpilotActionStates: (state) => {
      state.userpilotActionStates = initialUserpilotState();
    },
    setCurrentLoggedInInfo: (state, { payload }) => {
      state.currentLoggedInInfo = payload;
    },
    setIsChatBotAvailable: (state, { payload }) => {
      state.isChatBotAvailable = payload;
    },
    setRefreshProductAPI: (state, { payload }) => {
      state.callGetProductAPI = payload;
    },
    setFrappeRequestData: (state, { payload }) => {
      state.frappeRequestData = { ...state.frappeRequestData, ...payload };
    },
    setGlobalAlertData: (state, { payload }) => {
      state.globalAlertData = payload;
    },
  },
});

export const {
  setTheme,
  setNavPath,
  setName,
  setNotificationCount,
  setUserpilotOnboardingInfo,
  setUserpilotActionStates,
  setUserpilotSavedSteps,
  resetUserpilotActionStates,
  setCurrentLoggedInInfo,
  setIsChatBotAvailable,
  setRefreshProductAPI,
  setFrappeRequestData,
  setGlobalAlertData,
} = activity.actions;
export const activitySelector = (state) => state.activity;
export const activityReducer = activity.reducer;
export default activityReducer;

export const selectUserpilotState = (state) => state.activity.userpilotActionStates;
export const selectUserpilotOnboardingInfo = (state) => state.activity.userpilotOnboardingInfo;
export const selectUserpilotSavedSteps = (state) => state.activity.userpilotSavedSteps;
export const selectCurrentLoggedInInfo = (state) => state.activity.currentLoggedInInfo;
export const selectIsChatBotAvailable = (state) => state.activity.isChatBotAvailable;
export const selectCallGetProductAPI = (state) => state.activity.callGetProductAPI;
export const selectFrappeRequestData = (state) => state.activity.frappeRequestData;
export const selectGlobalAlertData = (state) => state.activity.globalAlertData;
